<template>
  <v-app>
    <v-navigation-drawer
     fixed
     dark
      v-model="drawer"
      app
    >
	  <router-link to="/">
		
		<template v-if="brandReady" class="text-xs-center">
		  	<div v-if="brand.id">
          <img class="pt-5 brand-logo-navigation" :src="brand.ManyEmpresaImage[0].description_source" alt="Propiedades en 9 de julio" />
      </div>
      <div v-else>
         <img  class="pt-5 brand-logo-navigation " src="./assets/logo.png" alt="Propiedades en 9 de julio"  />
      </div>


		</template>
	  </router-link>


        <v-list v-for="(item, i) in menu" :key="i">

          <v-list-tile  @click="drawer = false" router :to="item.link">
            <v-list-tile-content>
              <v-list-tile-title>{{item.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
		  <v-divider></v-divider>
        </v-list>

		<v-list>
          <template v-if="!brand.id">
            <v-list-tile  href="/admin/login/" target="_blank">
              <v-list-tile-content>
                <v-list-tile-title>Acceso Inmobiliarias</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

  		      <v-divider></v-divider>
          </template>
        </v-list>
    </v-navigation-drawer>

    <v-toolbar  v-if="brandReady" dark  app class="primary">
      <v-toolbar-side-icon @click.native.stop="drawer = !drawer" ></v-toolbar-side-icon>
	  	<router-link to="/">
			<v-toolbar-title v-if="!drawer">
				<template v-if="brand.id">
					<img class="brand-logo" :src="brand.ManyEmpresaImage[0].description_source" alt="Propiedades en 9 de julio" />
				</template>
				<template v-else>
					<img  class="brand-logo" src="./assets/logo.png" alt="Propiedades en 9 de julio" />
				</template>
			</v-toolbar-title>
		</router-link>

		<v-spacer></v-spacer>

		

		<template  v-for="(item, i) in menu">
			<v-btn  router :to="item.link"   small primary light class="hidden-sm-and-down">
				{{item.title}}
			</v-btn>
		</template>

		<v-spacer></v-spacer>
		<!--v-btn target="_blank" href="http://rs1.dev/admin/login" small primary >Acceso Inmobiliarias</v-btn-->



    </v-toolbar>
    <v-content>
      <v-container fluid  mt-3>
        
         <router-view></router-view>
	    
      </v-container>
    </v-content>

    <v-footer v-if="brandReady" >

      <v-layout row wrap>
        
        <v-flex xs6>
          <span v-if="brand.id">&copy; 2017-{{currentYear}} {{brand.description}} </span>
          <span v-else="brand.id">&copy; 2017-{{currentYear}} 9dejulio.com </span>
        </v-flex>
         <v-flex xs6>
           <p class="text-xs-right" v-if="brand.id">
            <a target="_blank" title="internet solutions" href="https://boxdata.com.ar"><img src="https://boxdata.com.ar/ext/boxdata_gris.gif"></a>
           </p>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import Isotope from 'vueisotope'
  import ImagesLoaded from 'vue-images-loaded'
  import axios from 'axios';
  export default {
    data () {
      return {
        drawer: false,
        menu: [],
        title: 'Inmuebles en 9 de Julio',
        currentYear: (new Date()).getFullYear()
      }
    },
    mounted() {
    axios.get(this.$apiUrl + 'empresa/item?url=' + window.location.hostname).then(response => {        
  				
  				this.$store.commit('brand', response.data.item);
          this.$vuetify.theme.primary = response.data.item.color_primary;
          //this.$ga.set({ id: response.data.item.gaid })

          this.menu = [
            { icon: 'bubble_chart', title: 'Propiedades', link: '/' },
            { icon: 'bubble_chart', title: 'Contacto', link: '/contacto' },
          ]
  		})
      .catch(e => {
            this.$store.commit('defaultBrand', 1);
          this.menu = [
            { icon: 'bubble_chart', title: 'Propiedades', link: '/' },
            { icon: 'bubble_chart', title: 'Inmobiliarias', link: '/inmobiliarias' },
            { icon: 'bubble_chart', title: 'Contacto', link: '/contacto' },
            //{ icon: 'bubble_chart', title: 'Mapa', link: '/mapa' }
          ]
      })
    },
    computed: {
        brand() {
            return this.$store.getters.brand;
        },
		brandReady () {
		  return this.$store.getters.brandReady
		}
    }
 }

</script>

<style>
.pace {
  -webkit-pointer-events: none;
  pointer-events: none;

  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;

  -webkit-transform: translate3d(0, -50px, 0);
  -ms-transform: translate3d(0, -50px, 0);
  transform: translate3d(0, -50px, 0);

  -webkit-transition: -webkit-transform .5s ease-out;
  -ms-transition: -webkit-transform .5s ease-out;
  transition: transform .5s ease-out;
}

.pace.pace-active {
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.pace .pace-progress {
  display: block;
  position: fixed;
  z-index: 2000;
  top: 0;
  right: 100%;
  width: 100%;
  height: 5px;
  background-color: #d50000;

  pointer-events: none;
}

nav.primary{
	padding:10px 0;
}
.brand-logo{
	height:50px;
}
.brand-logo-navigation{
  max-width:200px;
  margin:0 auto;
  display: block;
}
</style>
<style lang="stylus">
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// Esqueleto.vue?6182c7b8